import { userRoutes } from 'modules/user/routes/constants';

export const trainingsRoutes = {
  root: '/trainings',
  authenticated: `${userRoutes.root}/trainings`,
};
